import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Items from './views/Items.vue'
import Clients from './views/Clients.vue'
import Vendors from './views/Vendors.vue'
// import Orders from './views/Orders.vue'
import Docs from './views/Docs.vue'
// import Order from './views/Order.vue'
import Doc from './views/Doc.vue'

Vue.use(Router)

const base = ' - ATM'

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: route => {
          return 'Login' + base
        }
      }
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients,
      meta: {
        title: route => {
          return 'Clients' + base
        }
      }
    },
    {
      path: '/items',
      name: 'items',
      component: Items,
      meta: {
        title: route => {
          return 'Items' + base
        }
      }
    },
    {
      path: '/vendors',
      name: 'vendors',
      component: Vendors,
      meta: {
        title: route => {
          return 'Vendors' + base
        }
      }
    },
    /*
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
      meta: {
        title: route => {
          return 'Orders' + base
        }
      }
    },
    */
    {
      path: '/docs/:doctype',
      name: 'docs',
      component: Docs,
      meta: {
        title: route => {
          return 'Docs' + base
        }
      }
    },
    {
      path: '/docs/:doctype/:doc_id',
      name: 'doc',
      component: Doc,
      meta: {
        title: route => {
          return 'Doc' + base
        }
      }
    },
    /*
    {
      path: '/orders/:orderId',
      name: 'order',
      component: Order,
      meta: {
        title: route => {
          return 'Order' + base
        }
      }
    },
    */
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})